import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
const PageTitle = t0 => {
  const $ = _c(11);
  const {
    pageTitle,
    className,
    replacementIcon: t1
  } = t0;
  const replacementIcon = t1 === undefined ? false : t1;
  const t2 = `flex items-center ${className}`;
  let t3;
  if ($[0] !== replacementIcon) {
    t3 = replacementIcon && <FontAwesomeIcon icon={replacementIcon} className="inline text-primary group-hover:text-light text-3xl mr-1" />;
    $[0] = replacementIcon;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== replacementIcon) {
    t4 = !replacementIcon && <FontAwesomeIcon icon={faHiveIconSmallLight} className="inline text-primary group-hover:text-light text-3xl mr-1" />;
    $[2] = replacementIcon;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== pageTitle) {
    t5 = <h1 className="text-medium">{pageTitle}</h1>;
    $[4] = pageTitle;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t6 = <div className={t2}>{t3}{t4}{t5}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default PageTitle;